export default __webpack_public_path__ + "static/media/corona.0d9d1460.jpg";